import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";
import AlertService from "@/core/services/alert.service";
import router from '@/router'

// action types

export const PAGINATE_ALL_TRANSACTIONS = "getPaginatedTransactions";
export const FIND_BY_TRANSACTION_NAME = "findByTransactionName";
export const ALL_TRANSACTIONS = "getAllTransactions";
export const CREATE_TRANSACTION_FORM = "createTransactionForm";
export const DELETE_TRANSACTION = "deleteTransaction";
export const GET_TRANSACTION_DATA = "getTransactionData";
export const CREATE_TRANSACTION = "createTransaction";
export const UPDATE_TRANSACTION = "updateTransaction";
export const GET_TRANSACTIONS_REPORT = "getTransactionsReport";
export const GET_CREDIT_TRANSACTIONS_REPORT = "getCreditTransactionsReport";


// mutation types

export const SET_PAGINATED_TRANSACTIONS = "setPaginatedTransactions";
export const SET_ALL_TRANSACTIONS = "setAllTransactions";
export const SET_TRANSACTION_DATA = "setTransactionData";
export const SET_TRANSACTION_META = "setTransactionMeta";
export const SET_TRANSACTION_ERROR = "setTransactionError";
export const SET_TRANSACTION_LOADING = "setTransactionLoading";
export const CLEAR_TRANSACTION_ERROR = "clearTransactionError";
export const SET_IS_DISABLED_TRANSACTION = "setIsDisabledTransaction";


const state = {
    transactions: [],
    paginatedTransactions: [],
    transaction_data: {},
    meta_transaction : {
        totalPages: 0,
        total: 0,
        from: 0,
        to: 0,
    },
    errors: [],
    loading: false,
    isDisabled: false
    };

const getters = {
   
    paginateAllTransactions(state) {
        return state.paginatedTransactions;
    },

    allTransactions(state) {
        return state.transactions;
    },

    getTransactionData(state) {
        return state.transaction_data;
    },

    meta_transaction(state) {
        return state.meta_transaction;
    },
    
};

const actions = {
 
    [PAGINATE_ALL_TRANSACTIONS](context, payload) {
        context.commit(SET_IS_DISABLED_TRANSACTION, false);
        context.commit(SET_TRANSACTION_LOADING, true);
        JwtService.getToken();
        ApiService.setHeader();
        ApiService.get(`/transactions?size=${payload.itemsPerPage}&page=${payload.pageNumber}&sortBy=${payload.sortBy}&sortDesc=${payload.sortDesc}&searchText=${payload.search}&check=${payload.x}`)
        .then(({ data }) => {
            
            if(data == 403) {
                context.commit(SET_TRANSACTION_LOADING, false);
                router.push('nopermission');
            }
            else {
                context.commit(SET_PAGINATED_TRANSACTIONS, data);
                context.commit(SET_TRANSACTION_META, data);
                context.commit(SET_TRANSACTION_LOADING, false);
            }
            
        })
        .catch(( response ) => {
            context.commit(SET_TRANSACTION_LOADING, false);
            context.commit(SET_TRANSACTION_ERROR, response.errors);
        });
        ;
        
    },

    [FIND_BY_TRANSACTION_NAME](context, payload) {
        context.commit(SET_IS_DISABLED_TRANSACTION, false);
        context.commit(SET_TRANSACTION_LOADING, true);
        JwtService.getToken();
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.get(`/findByTransactionName?searchText=${payload.searchText}&check=${payload.x}`)
            .then((response) => {
                resolve(response);
            })
        });
    },


    [ALL_TRANSACTIONS]() {
        return new Promise(resolve => {
            ApiService.get('/transactionsAll')
            .then((response) => {
                resolve(response);
            })
        });
    },

    [CREATE_TRANSACTION_FORM](context) {
        context.commit(SET_TRANSACTION_LOADING, false);
        context.commit(SET_TRANSACTION_ERROR, false);
        context.commit(SET_IS_DISABLED_TRANSACTION, false);
    },

    [GET_TRANSACTION_DATA](context, payload) {
        context.commit(SET_IS_DISABLED_TRANSACTION, true);
        context.commit(SET_TRANSACTION_LOADING, true);
        context.commit(CLEAR_TRANSACTION_ERROR);
        return new Promise(resolve => {
            ApiService.get(`/transaction/${payload.id}`)
            .then(( response ) => {
                if(response.data == 403) {
                    context.commit(SET_TRANSACTION_LOADING, false);
                    router.push('/nopermission');
                }
                else {
                    context.commit(SET_TRANSACTION_DATA, response.data);
                    context.commit(SET_TRANSACTION_LOADING, false);
                    context.commit(SET_IS_DISABLED_TRANSACTION, false);
                    resolve(response);
                }
            })
            .catch(({ response }) => {
                context.commit(SET_TRANSACTION_LOADING, false);
                context.commit(SET_TRANSACTION_ERROR, response.data.errors);
                context.commit(SET_IS_DISABLED_TRANSACTION, true);
            });
        });
    },

    [CREATE_TRANSACTION](context, payload) {
        context.commit(SET_TRANSACTION_LOADING, false);
        context.commit(SET_IS_DISABLED_TRANSACTION, true);
        context.commit(CLEAR_TRANSACTION_ERROR);
        return ApiService.post("/transaction/store", payload.data)
        .then(( response ) => {
            if(response.data == 403) {
                AlertService.makeToast(
                    "warning",
                    "Yetkisiz!",
                    "Bu modül üzerinde ekleme yetkiniz yoktur. Lütfen sistem yöneticisi ile görüşünüz."
                );
                context.commit(CLEAR_TRANSACTION_ERROR);
            }
            else{
                context.commit(SET_TRANSACTION_LOADING, false);
                AlertService.makeToast(
                    "success",
                    "Kayıt Başarılı",
                    "işlem başarıyla kaydedilmiştir. ID numarası: " + response.data.id
                );
                context.commit(CLEAR_TRANSACTION_ERROR);
                context.commit(SET_IS_DISABLED_TRANSACTION, false);
                if(payload.goBack){
                    router.go(-1);    
                }
                return response;
            }
        })
        .catch(({ response }) => {
            context.commit(SET_TRANSACTION_LOADING, false);
            context.commit(SET_TRANSACTION_ERROR, response.data.errors);
            context.commit(SET_IS_DISABLED_TRANSACTION, false);
            AlertService.makeToast(
                "danger",
                "Hata!",
                "Lütfen aşağıdaki hataları düzeltiniz veya eksiklikleri gideriniz."
            );
        });
    },

    [UPDATE_TRANSACTION](context, payload) {
        context.commit(SET_TRANSACTION_LOADING, true);
        context.commit(SET_IS_DISABLED_TRANSACTION, true);
        context.commit(CLEAR_TRANSACTION_ERROR);
        
        return ApiService.put(`/transaction/${payload.data.id}`, payload.data)
        .then((response) => {
            
            if(response.data == 403){
                AlertService.makeToast(
                    "warning",
                    "Yetkisiz!",
                    "Bu modül üzerinde güncelleme yetkiniz yoktur. Lütfen sistem yöneticisi ile görüşünüz."
                );
                
            }
            else{
                context.commit(SET_TRANSACTION_LOADING, false);
                AlertService.makeToast(
                    "success",
                    "Güncelleme Başarılı",
                    payload.data.id + " ID numaralı işlem başarıyla güncellenmiştir."
                );
            
                context.commit(SET_IS_DISABLED_TRANSACTION, false);
                if(payload.goBack){
                    router.go(-1);    
                }
                
            return response;   
            }
                
        })
        .catch(({ response }) => {
            context.commit(SET_TRANSACTION_LOADING, false);
            context.commit(SET_TRANSACTION_ERROR, response.data.errors);
            context.commit(SET_IS_DISABLED_TRANSACTION, false);
            AlertService.makeToast(
                "danger",
                "Hata!",
                "Lütfen aşağıdaki hataları düzeltiniz veya eksiklikleri gideriniz."
            );
            
        });
        
    },

    [DELETE_TRANSACTION](context, payload) {
        context.commit(SET_TRANSACTION_LOADING, true);
        context.commit(CLEAR_TRANSACTION_ERROR);
        JwtService.getToken();
        ApiService.setHeader();
        ApiService.delete(`/transaction/${payload.itemToDelete}`)
        .then(( response ) => {
            context.commit(SET_TRANSACTION_LOADING, false);
            
            if(response.data == 403){
                AlertService.makeToast(
                    "warning",
                    "Yetkisiz!",
                    "Bu modül üzerinde silme yetkiniz yoktur. Lütfen sistem yöneticisi ile görüşünüz."
                );
                
            }
            else{
               
                AlertService.makeToast(
                    "success",
                    "Silme Başarılı",
                    payload.itemToDelete + " ID numaralı işlem başarıyla silinmiştir."
                );
                
            }
        })
        .catch(( error ) => {
            context.commit(SET_TRANSACTION_ERROR, error);
        });
        
    },

    [GET_TRANSACTIONS_REPORT](context, payload) {
        context.commit(SET_IS_DISABLED_TRANSACTION, true);
        context.commit(SET_TRANSACTION_LOADING, true);
        context.commit(CLEAR_TRANSACTION_ERROR);
        return new Promise(resolve => {
            ApiService.get(`/get_transactions_report?userid=${payload.user_id}&x=1`)
            .then(( response ) => {
                if(response.data == 403) {
                    context.commit(SET_TRANSACTION_LOADING, false);
                    router.push('/nopermission');
                }
                else {
                    context.commit(SET_TRANSACTION_DATA, response.data);
                    context.commit(SET_TRANSACTION_LOADING, false);
                    context.commit(SET_IS_DISABLED_TRANSACTION, false);
                    resolve(response);
                }
            })
            .catch(({ response }) => {
                context.commit(SET_TRANSACTION_LOADING, false);
                context.commit(SET_TRANSACTION_ERROR, response.data.errors);
                context.commit(SET_IS_DISABLED_TRANSACTION, true);
            });
        });
    },

    [GET_CREDIT_TRANSACTIONS_REPORT](context) {
        context.commit(SET_IS_DISABLED_TRANSACTION, true);
        context.commit(SET_TRANSACTION_LOADING, true);
        context.commit(CLEAR_TRANSACTION_ERROR);
        return new Promise(resolve => {
            ApiService.get(`/get_credit_transactions_report`)
            .then(( response ) => {
                if(response.data == 403) {
                    context.commit(SET_TRANSACTION_LOADING, false);
                    router.push('/nopermission');
                }
                else {
                    context.commit(SET_TRANSACTION_DATA, response.data);
                    context.commit(SET_TRANSACTION_LOADING, false);
                    context.commit(SET_IS_DISABLED_TRANSACTION, false);
                    resolve(response);
                }
            })
            .catch(({ response }) => {
                context.commit(SET_TRANSACTION_LOADING, false);
                context.commit(SET_TRANSACTION_ERROR, response.data.errors);
                context.commit(SET_IS_DISABLED_TRANSACTION, true);
            });
        });
    },
    
};

const mutations = {

    [SET_PAGINATED_TRANSACTIONS](state, paginatedTransactions) {
        state.paginatedTransactions = paginatedTransactions.data;
    },

    [SET_ALL_TRANSACTIONS](state, transactions) {
        state.transactions = transactions;
    },

    [SET_TRANSACTION_DATA](state, transactions_data) {
        state.transactions_data = transactions_data;
        state.errors = [];
    },

    [SET_TRANSACTION_META](state, meta_transaction) {
        state.meta_transaction = meta_transaction;
    },

    [SET_TRANSACTION_ERROR](state, error) {
        state.errors = error;
    },

    [CLEAR_TRANSACTION_ERROR](state) {
        state.errors = [];
    },
    
    [SET_TRANSACTION_LOADING](state, loading) {
        state.loading = loading;
    },

    [SET_IS_DISABLED_TRANSACTION](state, isDisabled) {
        state.isDisabled = isDisabled;
    },

};

export default {
    state,
    actions,
    mutations,
    getters
};
